import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as fonts from '@helpcenter/styles/src/fonts';
import { ThemedLink } from '@helpcenter/themed-link';
import type { WrappedComponentProps } from 'react-intl';
import { injectIntl, FormattedMessage } from 'react-intl';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

import messages from './messages';

export interface Props {
	isError: boolean;
}

export const AnonymousEmailSignupMessage = ({ isError, intl }: Props & WrappedComponentProps) => {
	return (
		<Wrapper>
			{isError ? (
				<StatusErrorIcon label="error" color={token('color.icon.danger', '#FF5630')} />
			) : (
				<StatusWarningIcon label="warning" color={token('color.icon.warning', '#FFAB00')} />
			)}

			<SignupMessage isError={isError}>
				<FormattedMessage
					{...messages.signupWarningMessage}
					values={{
						signUpLink: (
							<ThemedLink to={'/user/login'} target="_blank" actionSubjectId="signupLink">
								{intl.formatMessage(messages.signupLink)}
							</ThemedLink>
						),
					}}
				/>
			</SignupMessage>
		</Wrapper>
	);
};

export default injectIntl(AnonymousEmailSignupMessage);

const requestCreateFieldErrorColor = token('color.text.danger', '#BF2600');
const anonymousEmailSignupWarningTextColor = token('color.text.subtlest', '#6B778C');
interface SignupMessageProps {
	isError?: boolean;
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const SignupMessage = styled.span<SignupMessageProps>`
	${fonts.xsmall};
	/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
	color: ${(props) =>
		props.isError ? requestCreateFieldErrorColor : anonymousEmailSignupWarningTextColor};
	font-weight: 500;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Wrapper = styled.div`
	display: flex;
	margin-top: ${token('space.050', '4px')};
`;
